<div class="call-as-dial">
  @for (item of data; track item) {
    <div class="dial-item" (mousedown)="onDialButtonDown(item)" (mouseup)="onDialButtonUp()" [class.disabled]="isDisabled">
      <div class="dial-number">{{ item.dialNumber }}</div>
      <div class="dial-alphabet">{{ item.dialAlphabet }}</div>
      @if (isDisabled) {
        <nimbus-tooltip [text]="translations.CallAsServiceDoesntHaveLicenseToCalls | translate"></nimbus-tooltip>
      }
    </div>
  }
</div>
